import { FixedPageHeader } from 'Components/Layout';
import { useSelector } from 'react-redux';

const FixedAgsProjectHeader: React.FC = () => {
  const status = useSelector((state) => state.agsProjectExport.pageHeader?.status);
  const processing = useSelector((state) => state.agsProjectExport.pageHeader?.processing);
  const caption = useSelector((state) => state.agsProjectExport.pageHeader?.shortName);
  const identifier = useSelector((state) => state.agsProjectExport.pageHeader?.identifier);

  return (
    <FixedPageHeader
      pageIdentifier={identifier}
      pageStatus={status}
      pageProcessing={processing}
      pageCaption={caption}
    />
  );
};

export default FixedAgsProjectHeader;
